module.exports = __webpack_public_path__ + "fonts/MuseoSlab-500.3e8abfd3.woff2";